function animateNumber(el, target, suffix = '') {
  let start = 0;
  const duration = 1500;
  const frameRate = 60;
  const totalFrames = Math.round(duration / (1000 / frameRate));
  let frame = 0;

  const suffixEl = el.querySelector('.impact-stats__suffix');

  const count = () => {
    frame++;
    const progress = frame / totalFrames;
    const current = Math.round(target * progress);

    el.childNodes[0].nodeValue = current; // змінюємо лише число
    if (suffixEl) suffixEl.textContent = suffix;

    if (frame < totalFrames) {
      requestAnimationFrame(count);
    } else {
      el.childNodes[0].nodeValue = target;
      if (suffixEl) suffixEl.textContent = suffix;
    }
  };

  count();
}

function initImpactStats() {
  const counters = document.querySelectorAll('[data-animate-number]');
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const target = parseInt(el.dataset.target.replace(/\D/g, ''), 10);
          const suffix = el.dataset.suffix || '';
          animateNumber(el, target, suffix);
          obs.unobserve(el);
        }
      });
    },
    { threshold: 0.6 }
  );

  counters.forEach((el) => observer.observe(el));
}

document.addEventListener('DOMContentLoaded', initImpactStats);
